<template>
  <div>
    <div class="content" v-if="!uploaded">
      <div class="condition-box anli-txt">
        <h2 class="title">案例分析解决方案综述</h2>
        <div class="clearfix">
          <div class="left">
          <p>
            报告语言：英文<br />
            封面内容：报告名称、团队名称、团队口号、团队成员姓名、大学/学院全称<br />
            文件格式：Word <br />
            排版要求：缩进二个字，1.5倍行距 <br />
            字体要求：Arial，小四号 <br />
            字数限制：4000字以内，图表不计入字数限制
          </p>
        </div>
        <div class="right">
          <p>
            案例分析解决方案综述：总结和提炼解决方案，内容包含辅助现场演讲用到的背景资料等关键信息。将在比赛开始前提交给评委。
            <br />
            篇幅：2 页 A4 纸 <br />
            文件格式：Word <br />
            排版要求：缩进二个字，1.5倍行距<br />
            字体要求：Arial，小四号
          </p>
        </div>
        </div>
      </div>
      <div class="file-box" style="margin-bottom: 0">
        <el-upload
          ref="uploadFile"
          class="upload-demo"
          :action="imgHost + '/user/upload'"
          :headers="uploadHeader"
          :on-preview="handlePreview"
          :data="uploadData"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          auto-upload
          :on-success="uploadSuccess"
          :before-upload="beforeAvatarUpload"
          accept=".doc,.docx"
        > 
          <el-button size="small" type="primary">点击上传</el-button>
          <template #tip>
            <div class="el-upload__tip">只能上传Word文件</div>
          </template>
        </el-upload>
        <div class="team-button-box">
          <!-- <el-button class="pre">上一步</el-button> -->
          <el-button class="next" size="small" @click="next" type="primary">提交</el-button>
        </div>
      </div>
    </div>
    <div class="status-box" v-else>
      <div class="img-box">
        <img src="../../assets/images/team/submit.png" alt="" />
        <p>案例已提交成功</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiSetProcess,
  apiGetProcess
}from '../../plugins/apis'
export default {
  data() {
    return {
      imgHost:process.env.VUE_APP_API_URL,
      uploadHeader:{ Authorization: window.localStorage.app_token },
      uploadData:{},
      fileList:[],
      uploaded:false
    };
  },
  async mounted(){
    this.uploadData = {
      file_source:1
    }
    await this.getView()
  },
  props:['round','label'],
  watch:{
    'label'(){
      this.getView()
    }
  },
  methods: {
    async getView(){
      let res = await apiGetProcess(this.round.round_id,this.label)
      if(res.code === 200){
        this.uploaded = res.data ? true:false
      }
    },
    async next(){
      if(this.processData.file_id === undefined || this.processData.file_id === '' || !this.processData.file_id){
        this.$message.error('请上传文件')
        return
      }
      let r = await apiSetProcess(this.round.round_id,this.label,this.processData)
      if(r.code === 500){
        this.$message.error(r.message)
        return
      }
      await this.getView()
      this.$Bus.$emit('reload_NowProcess');
    },
    beforeAvatarUpload(file) { 
      let fileArr = file.name.split('.')
      let bul = ['doc','docx'].indexOf(fileArr.pop()) > -1
      if(bul) {
        return true;
      }else{
        this.$message.error('只能上传ppt文件')
        return false
      }
    },
    uploadSuccess(e){
      if(e.code === 200){
        this.$message.success('上传成功')
        this.processData = {
          file_id:e.data.file_id,
        }
      }else[
        this.$message.error('上传失败')
      ]
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed() {
      this.fileList = []
      this.$refs.uploadFile.submit()
    }
  },
};
</script>

<style>
</style>